import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'

/**
 * Empty state component for users list
 */
export const UsersEmpty: React.FC = () => {
	const { t } = useTranslation('common')
	return (
		<div className="p-6 text-center text-muted-foreground">
			{t('account.users.empty_state')}
		</div>
	)
}
